import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { fetchSensemakerOverview } from './sensemaker-overview.api'

export function useSensemakerOverview(tenantId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.tenants.detail(tenantId ?? ''),
    queryFn: () => fetchSensemakerOverview(tenantId!),
    enabled: Boolean(tenantId),
  })
}
